export enum ContractType {
  LIQUIDITY_POOL_DATA = 'liquidityPoolDataContract',
  LIQUIDITY_POOL = 'liquidityPoolContract',
  PRICE_FEED = 'priceFeedContract',
  MULTICOLLATERAL = 'multiCollateralContract',
  MULTICOLLATERAL_ON_OFF_RAMP = 'multiCollateralOnOffRampContract',
  SPORTS_AMM_DATA = 'sportsAMMDataContract',
  SPORTS_AMM_V2 = 'sportsAMMV2Contract',
  SPORTS_AMM_V2_RISK_MANAGER = 'sportsAMMV2RiskManagerContract',
  SPORTS_AMM_V2_RESULT_MANAGER = 'sportsAMMV2ResultManagerContract',
  LIVE_TRADING_PROCESSOR = 'liveTradingProcessorContract',
  LIVE_TRADING_PROCESSOR_DATA = 'liveTradingProcessorDataContract',
  SGP_TRADING_PROCESSOR = 'sgpTradingProcessorContract',
  FREE_BET_HOLDER = 'freeBetHolderContract',
  SPORTS_AMM_V2_MANAGER = 'sportsAMMV2ManagerContract',
  MULTICALL = 'multiCallContract',
  STAKING_THALES_BETTING_PROXY = 'stakingThalesBettingProxy',
  RESOLVE_BLOCKER = 'resolveBlockerContract',
  THALES_TO_OVER_MIGRATION = 'thalvesToOverMigrationContract',
  THALES = 'thalvesContract',
}
